import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { tagPrefixCls } from "@/base/components/tag/Tag.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Tag">> = ({
  fontSizeIcon,
  defaultColor,
  defaultColorWarning,
  defaultColorError,
  defaultColorSuccess,
  defaultColorProcessing,
  softBg,
  softColor,
  softBgWarning,
  softColorWarning,
  softBgError,
  softColorError,
  softBgSuccess,
  softColorSuccess,
  softBgProcessing,
  softColorProcessing,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${tagPrefixCls}`]: {
      lineHeight: `22px`,
      minWidth: `24px`,
      minHeight: `24px`,

      [`.${tagPrefixCls}-close-icon`]: {
        marginInlineStart: 8,
        fontSize: `${fontSizeIcon}px`,
      },

      [`&.${tagPrefixCls}-warning`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorWarning,
        borderColor: defaultColorWarning,
      },

      [`&.${tagPrefixCls}-error`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorError,
        borderColor: defaultColorError,
      },

      [`&.${tagPrefixCls}-success`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorSuccess,
        borderColor: defaultColorSuccess,
      },

      [`&.${tagPrefixCls}-processing`]: {
        color: `${defaultColor}`,
        backgroundColor: defaultColorProcessing,
        borderColor: defaultColorProcessing,
      },

      // Soft variant: tinted background with a readable coloured label.
      // Two classes beat the solid rules above on specificity, so rule order
      // does not matter here.
      [`&.${tagPrefixCls}-soft`]: {
        color: `${softColor}`,
        backgroundColor: softBg,
        borderColor: `transparent`,

        [`&.${tagPrefixCls}-warning`]: {
          color: `${softColorWarning}`,
          backgroundColor: softBgWarning,
          borderColor: `transparent`,
        },

        [`&.${tagPrefixCls}-error`]: {
          color: `${softColorError}`,
          backgroundColor: softBgError,
          borderColor: `transparent`,
        },

        [`&.${tagPrefixCls}-success`]: {
          color: `${softColorSuccess}`,
          backgroundColor: softBgSuccess,
          borderColor: `transparent`,
        },

        [`&.${tagPrefixCls}-processing`]: {
          color: `${softColorProcessing}`,
          backgroundColor: softBgProcessing,
          borderColor: `transparent`,
        },
      },
    },
  },
});

export const useTagStyle = genComponentStyleHook(["Tag", "cso"], (token) => {
  return [genStyle(token)];
});
